
import React from 'react';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import { Button, Form, Message, Dimmer, Loader } from 'semantic-ui-react';

import ReportMeta from 'op/components/report/meta';

import { withLocale } from 'op/components/locale';
import { withReportCreation } from './report-create.helper';

const ReportCreate = ({ locale, validation, isFirstTime, isCreating, report, invokeChange, submitReport }) => (
  <Form error={ !isFirstTime && !validation.ok }>
    <Dimmer active={ isCreating } inverted page>
      <Loader />
    </Dimmer>
    <ReportMeta { ...{ report, invokeChange } } />
    <Message
      error
      header={ locale._system.validation.negative }
      content={ validation.message }
    />
    <Button fluid primary onClick={ submitReport } disabled={ !validation.ok } >{ locale._system.createTask }</Button>
  </Form>
);

export { createReportBase } from './report-create.helper';

export default compose(
  withLocale(),
  withReportCreation,
  hot(module),
)(ReportCreate)